import classNames from "classnames";
import React from "react";
import linkArrowIcon from "../assets/images/link-arrow.svg";
import { LinkInfo } from "../models/shared/LinkInfo";
import { isNullOrWhiteSpace } from "../shared/string";
import SanityLink, { renderLinkTitle } from "./SanityLink";

type Column = {
  title?: string;
  links?: LinkInfo[];
};

export interface LinkColumnListProps {
  title?: string;
  subtitle?: string;
  column1?: Column;
  column2?: Column;
  column3?: Column;
}

function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined;
}

const LinkColumnList = ({
  title,
  subtitle,
  column1,
  column2,
  column3
}: LinkColumnListProps) => {
  const columns: Column[] = [column1, column2, column3].filter(notEmpty);

  return (
    <aside className="px-0 overflow-hidden">
      {!isNullOrWhiteSpace(title) && (
        <div className="pb-12">
          <h2 className="text-current px-4 mb-2">{title}</h2>
          {!isNullOrWhiteSpace(subtitle) && (
            <h3 className="text-subheader-primary px-4">{subtitle}</h3>
          )}
        </div>
      )}

      <div className="px-4 relative z-10 grid lg:grid-flow-col gap-8">
        {columns.map((column, index) => (
          <div key={index} className="flex flex-col overflow-hidden">
            {!isNullOrWhiteSpace(column.title) && (
              <h3 className="text-current text-2xl lg:text-3.5xl">{column.title}</h3>
            )}
            <ul
              className={classNames(
                "flex lg:flex-col overflow-x-auto pt-2 pb-12",
                isNullOrWhiteSpace(column.title) && "lg:pt-16"
              )}
            >
              {column.links?.map((link, index) => (
                <li
                  key={index}
                  className="card-basic group hover:border-brand-primary-70 focus:outline-none focus:shadow-card-outline min-w-card-small mr-2 lg:mr-0 lg:mb-8 last:mb-0"
                >
                  <SanityLink
                    className="text-brand-primary-20 flex items-center justify-between w-full p-6 no-underline"
                    {...link}
                  >
                    <p className="text-brand-primary-20 mb-0 font-bold uppercase text-ellipsis overflow-hidden">
                      {renderLinkTitle(link)}
                    </p>
                    <svg className="card-arrow group-hover:text-brand-primary-70 w-4 h-4 ml-4">
                      <use xlinkHref={linkArrowIcon.url} />
                    </svg>
                  </SanityLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </aside>
  );
};

export default LinkColumnList;

